import axios from "axios";

export default function fetchAllPages(baseUrl) {
  var separator = baseUrl.includes("?") ? "&" : "?";

  return axios.get(baseUrl).then(function(firstRes) {
    var allItems = firstRes.data.data || [];
    var pagination = firstRes.data.meta && firstRes.data.meta.pagination;
    var totalPages = (pagination && pagination.total_pages) || 1;

    if (totalPages <= 1) {
      return allItems;
    }

    var pageRequests = [];
    for (var page = 2; page <= totalPages; page++) {
      pageRequests.push(axios.get(baseUrl + separator + "_page=" + page));
    }

    return Promise.all(pageRequests).then(function(responses) {
      responses.forEach(function(res) {
        allItems = allItems.concat(res.data.data || []);
      });
      return allItems;
    });
  });
}
